<template>
<div>
  <v-alert :value="show" dismissible @click="dismiss(item)"
  :key="item.id" v-for="item in items" :type="priorityVariant[item.priority-1]">
      {{item.text}}
  </v-alert>
</div>

</template>

<script>
import { EventBus } from '@/router/bus'
import { getUser, getNotificationInfo, setNotificationInfo } from '@/utils/cookie'

export default {
  data () {
    return {
      priorityVariant: ['info', 'warning', 'error'],
      show: false,
      showList: false,
      items: []
    }
  },
  created () {
    EventBus.$on('notification', this.showNotifications)
    EventBus.$on('notification-close', this.dismiss)
  },
  methods: {
    showNotifications (data) {
      // Filter incoming data to get only non-dismissed items
      this.items = this.getNondismissed(data)
      if (this.items.length === 0) {
        return
      }

      this.show = true
    },
    dismiss (item) {
      // this.show = false
      this.updateDismissed(item)

      var index = this.items.indexOf(item)
      if (index > -1) { this.items.splice(index, 1) }
    },
    updateDismissed (item) {
      var notificationInfo = this.getCurrentNotificationInfo()
      notificationInfo.push(item.id)
      this.setCurrentNotificationInfo(notificationInfo)
    },
    setCurrentNotificationInfo (info) {
      var key = getUser()
      setNotificationInfo(key, info)
    },
    getNondismissed (data) {
      var notificationInfo = this.getCurrentNotificationInfo()
      var nondismissed = []
      for (var i = 0; i < data.length; i++) {
        if (!(notificationInfo.includes(data[i].id))) {
          nondismissed.push(data[i])
        }
      }
      return nondismissed
    },
    getCurrentNotificationInfo () {
      var key = getUser()
      var notificationInfo = getNotificationInfo(key)

      if (notificationInfo == null) {
        notificationInfo = []
        // setNotificationInfo(key, notificationInfo)
      }

      return notificationInfo
    }
  }
}
</script>
<style lang="scss" type="text/scss" scoped>
    .notification-top {
        position: relative;
        top: 64px;
        z-index: 100;
        border-radius: 0;
        margin-left: 5px;
        width: calc(100% - 10px);
    }

    .notification-item {
      margin-right: 4rem !important;
    }

    .danger-notification-icon {
      width: 28px;
      height: 28px;
      line-height: 32px;
      margin: 0px;
      margin-right: 15px;
    }

    .warning-notification-icon {
      width: 30px;
      height: 30px;
      margin: 0px;
      margin-right: 15px;
    }

    .info-notification-icon {
      width: 28px;
      height: 28px;
      margin: 0px;
      margin-right: 15px;
    }
</style>
